export const GET_IFA_INDIVIDUALS = "INDIVIDUAL.GET_IFA_INDIVIDUALS";
export const GET_IFA_INDIVIDUALS_SUCCESS = "INDIVIDUAL.GET_IFA_INDIVIDUALS_SUCCESS";
export const GET_IFA_INDIVIDUALS_ERROR = "INDIVIDUAL.GET_IFA_INDIVIDUALS_ERROR";
export const CHANGE_FUNDS_SUCCESS = "INDIVIDUAL.CHANGE_FUNDS_SUCCESS";
export const CHANGE_FUNDS_ERROR = "INDIVIDUAL.CHANGE_FUNDS_ERROR";
export const CHANGE_FUNDS = "INDIVIDUAL.CHANGE_FUNDS";
export const REQUEST_ACCESS = "INDIVIDUAL.REQUEST_ACCESS";
export const REQUEST_ACCESS_SUCCESS = "INDIVIDUAL.REQUEST_ACCESS_SUCCESS";
export const REQUEST_ACCESS_ERROR = "INDIVIDUAL.REQUEST_ACCESS_ERROR";
